module.exports = __webpack_public_path__ + "img/phone-bg.eee89f37.png";